import axios from 'axios';
import React, { useEffect, useRef, useState } from 'react';
import config from '../../Config';
import { toast, ToastContainer } from 'react-toastify';
import { Link, NavLink, useNavigate } from 'react-router-dom';
import { Form } from 'react-bootstrap';
import WebsiteMenu from './WebsiteMenu';
import { Editor } from '@tinymce/tinymce-react';

const DateSheetSetting = () => {
    document.title = "Date Sheet Setting";

    const AccessKey = localStorage.getItem("AccessKey");
    const UserID = localStorage.getItem("ID");
    const [MemberType] = useState("Website");
    const [loading, setLoading] = useState(false);
    const [ContentPage, setContentPage] = useState({});
    const [voucherEnabled, setVoucherEnabled] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        setLoading(true);
        const data = {
            AccessKey,
            UserID,
            MemberType,
            ID: 4
        };

        const api_config = {
            method: 'post',
            url: config.base_url + 'ContentPage/GetContentPageByID',
            headers: { 'Content-Type': 'application/json' },
            data
        };

        axios(api_config)
            .then((response) => {
                if (response.data.status_code === 1) {
                    const pageData = response.data.ContentPage;
                    setContentPage(pageData);

                } else {
                    toast.error(response.data.status_message || 'Failed to load content.', {
                        position: toast.POSITION.TOP_RIGHT
                    });
                }
                setLoading(false);
            })
            .catch(() => {
                setLoading(false);
                toast.error('Network Error.', { position: toast.POSITION.TOP_RIGHT });
            });
    }, []);

    const handleSubmit = (e) => {
        e.preventDefault();

        const form = e.target;
        if (!form.checkValidity()) {
            e.stopPropagation();
            toast.error('Please fill in all required fields.', {
                position: toast.POSITION.TOP_RIGHT
            });
            return;
        }

        setLoading(true);

        const data = {
            AccessKey,
            UserID,
            ID: 4,
            Page_Title: e.target.txtPage_Title.value,
            Page_Detail: editorContent,
            Meta_Title: e.target.txtPage_Title.value,
            Meta_Description: e.target.txtPage_Title.value,
            Meta_Keywords: e.target.txtPage_Title.value,
            Header_Image: ''
        };

        const api_config = {
            method: 'post',
            url: config.base_url + 'ContentPage/UpdateContentPage',
            headers: { 'Content-Type': 'application/json' },
            data
        };

        axios(api_config)
            .then((response) => {
                if (response.data.status_code === 1) {
                    toast.success(response.data.status_message, {
                        position: toast.POSITION.TOP_RIGHT
                    });
                } else if (response.data.status_message === 'Invalid Access Key.') {
                    navigate('/web-admin/login');
                } else {
                    toast.error(response.data.status_message, {
                        position: toast.POSITION.TOP_RIGHT
                    });
                }
                setLoading(false);
            })
            .catch(() => {
                setLoading(false);
                toast.error('Network Error.', { position: toast.POSITION.TOP_RIGHT });
            });
    };

    const editorRef = useRef(null);
    const [editorContent, setEditorContent] = useState("");
    const handleEditorChange = (content, editor) => {
        setEditorContent(content);
    };

    return (
        <>
            <ToastContainer />
            <WebsiteMenu />

            <div className="container body-content">
                <div className="page-head">
                    <div className="container">
                        <div className="row align-items-center">
                            <div className="col-md-6">
                                <nav aria-label="breadcrumb">
                                    <ol className="breadcrumb">
                                        <li className="breadcrumb-item"><Link to="/Dashboard">Dashboard</Link></li>
                                        <li className="breadcrumb-item active" aria-current="page">Date Sheet</li>
                                    </ol>
                                </nav>
                                <div className="page-title">Date Sheet</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div>
                    <div className="page-content">
                        <div className="container">
                            <Form noValidate onSubmit={handleSubmit}>
                                <div className="row align-items-end g-3">
                                    <div className="col-md-12">
                                        <div className="card">
                                            <div className="card-body p-3">
                                                <div className="row gy-3">
                                                    <div className="col-md-12">
                                                        <div className="form-group">
                                                            <label htmlFor="">Title:</label>
                                                            <input type="text" defaultValue={ContentPage.Page_Title} className="form-control" required name="txtPage_Title" />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-12">

                                                        <div className="form-group">
                                                            <label className="">Date Sheet Details :</label>
                                                            <Editor
                                                                apiKey={config.Editor_Apikey}

                                                                init={{
                                                                    height: 400,
                                                                    plugins: 'table',
                                                                    toolbar: 'undo redo | styleselect | bold italic | alignleft aligncenter alignright | table',
                                                                }}
                                                                initialValue={ContentPage.Page_Detail}
                                                                onInit={(evt, editor) => editorRef.current = editor}
                                                                onEditorChange={handleEditorChange}
                                                            />
                                                        </div>
                                                    </div>

                                                    <div className="col-md-3 offset-md-9">
                                                        <button
                                                            type="submit"
                                                            className="button button-primary w-100 mt-4"
                                                            disabled={loading}
                                                        >
                                                            {loading ? 'Updating...' : 'Update'}
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </Form>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default DateSheetSetting;
